module.exports = __webpack_public_path__ + "img/dog-profile.cdaeda2e.jpeg";